<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">ปี พ.ศ.(Year)</th>
              <th class="text-center">ชื่อหลักสูตร (Subject of Course)</th>
              <th class="text-center">ชื่อสถาบัน (Institus)</th>
              <th class="text-center">จำนวนชั่วโมง (Hour)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in 3" :key="i">
              <td>
                <v-select
                  v-model="$store.state.dataFrm.list_train.cou_year[i]"
                  :items="$store.getters.get_ListYear"
                  item-text="yearStr"
                  item-value="yearStr"
                  :label="i + 1 + ') ปี พ.ศ.'"
                ></v-select>
              </td>
              <td>
                <v-text-field
                  v-model="$store.state.dataFrm.list_train.cou_object[i]"
                  label="ชื่อหลักสูตร (Subject of Course)"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_train.cou_place[i]"
                  label="ชื่อสถาบัน (Institus)"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-text-field
                  type="number"
                  v-model="$store.state.dataFrm.list_train.cou_hour[i]"
                  label="ระยะเวลา (Period)"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {};
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
